import { memo } from 'react'
import { GS } from 'back-end-api'
import { useTranslation } from 'services/Translation'
import img1 from 'assets/doctorProfile/1.png'
import img2 from 'assets/doctorProfile/2.png'
import img3 from 'assets/doctorProfile/3.png'
import img4 from 'assets/doctorProfile/4.png'
import img5 from 'assets/doctorProfile/5.png'
import img6 from 'assets/doctorProfile/6.png'

import { useAccountSection, ACCOUNT_SECTIONS } from 'components/account/context'

const texts = (getText) => (key) =>
  ({
    myAccount: getText('My Account', 'Account_Sidebar'),
    walletAnalytics: getText('Wallet & Analytics', 'Account_Sidebar'),
    settings: getText('Settings', 'Account_Sidebar'),
    helpSupport: getText('Help & Support', 'Account_Sidebar'),
    termsPrivacy: getText('Terms & Privacy', 'Account_Sidebar'),
    logOut: getText('Log Out', 'Account_Sidebar'),
  }[key])

const logout = () => {
  localStorage.clear()
  window.location.href = '/'
}

const DoctorProfileSidebar = () => {
  const { t } = useTranslation(texts)
  const { section, setSection } = useAccountSection()

  // In-house (employed) doctors do not participate in the freelance wallet, so
  // the Wallet & Analytics entry is hidden for them (Requirements 4.1, 5.1).
  const account = GS.useOwnAccount({ refreshInterval: 0 })
  const inHouse = Boolean(account?.data?.in_house_doctor)

  const menuItems = [
    { id: 1, icon: img1, label: t('myAccount'), section: ACCOUNT_SECTIONS.PROFILE },
    {
      id: 2,
      icon: img2,
      label: t('walletAnalytics'),
      section: ACCOUNT_SECTIONS.WALLET,
      hidden: inHouse,
    },
    { id: 3, icon: img3, label: t('settings'), section: ACCOUNT_SECTIONS.SETTINGS },
    { id: 4, icon: img4, label: t('helpSupport') },
    { id: 5, icon: img5, label: t('termsPrivacy') },
    { id: 6, icon: img6, label: t('logOut'), onClick: logout },
  ]

  const handleActivate = (item) => {
    if (item.onClick) {
      item.onClick()
    } else if (item.section) {
      setSection(item.section)
    }
  }

  return (
    <div className="flex flex-col space-y-2 px-4 mt-6">
      {menuItems
        .filter((item) => !item.hidden)
        .map((item) => {
          const isActive = Boolean(item.section) && item.section === section
          return (
            <div
              key={item.id}
              role="button"
              tabIndex={0}
              onClick={() => handleActivate(item)}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault()
                  handleActivate(item)
                }
              }}
              className={`relative flex items-center space-x-3 p-3 rounded-lg cursor-pointer transition-all duration-200
              ${
                isActive
                  ? 'bg-[#EEF1FD] text-[#2e4ce6] translate-x-2 shadow-sm border-l-4 border-[#2e4ce6]'
                  : 'text-gray-700 hover:bg-gray-100'
              }`}
            >
              <img src={item.icon} alt={item.label} className="w-5 h-5 object-contain" />
              <span className="text-sm font-csc55">{item.label}</span>
            </div>
          )
        })}
    </div>
  )
}

DoctorProfileSidebar.whyDidYouRender = true

export default memo(DoctorProfileSidebar)
